import { RootState } from "../reducers";

export const getLayersTs = ({ layers }: RootState) => layers?.ts;

export const getLayerInfosLoading = ({ layers }: RootState) => layers?.layerInfosLoading;

export const getLayerInfosError = ({ layers }: RootState) => layers?.layerInfosError;
